import { accountActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  auth: false,
  user: null,
  status: '',
  message: ''
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.ACCOUNT_SUCCESS: {
      const { auth, message } = action.payload;
      return {
        ...state,
        auth,
        status: 'success',
        message
      };
    }

    case actionType.NEED_SMS: {
      const { message } = action.payload;
      return {
        ...state,
        auth: false,
        status: 'needSMS',
        message
      };
    }

    case actionType.LOAD_USER: {
      const { user, auth } = action.payload;
      return {
        ...state,
        auth,
        user
      };
    }

    case actionType.CHANGE_PASSWORD: {
      const { auth } = action.payload;
      return {
        auth,
        user: { ...state.user, changePassword: false },
        status: 'success',
        message: 'Password changed'
      };
    }

    case actionType.ACCOUNT_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        status: 'error',
        message: error
      };
    }

    case actionType.LOGOUT: {
      return {
        ...state,
        user: null,
        auth: false,
        status: '',
        message: ''
      };
    }

    case actionType.SET_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        status,
        message: ''
      };
    }

    case actionType.SET_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        status: 'error',
        message: error
      };
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
